import { CURRENCY } from "@/data/catalog";

export const formatPrice = (value) =>
  `${CURRENCY}${Number(value).toFixed(2)}`;
